const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  gaTrackingID: process.env.REACT_APP_GA_TRACKING_ID
}

export default config
